export const PLUGIN_VERSION = window?.wyA11yGlobals?.version ?? "";
